var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReload = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 20C3.33398 23.9782 4.91434 27.7936 7.72738 30.6066C10.5404 33.4196 14.3557 35 18.334 35C22.3173 35 26.134 33.4333 29.0007 30.6667L26.5007 28.1667C25.4514 29.2779 24.1852 30.1619 22.7804 30.7639C21.3757 31.3659 19.8623 31.6732 18.334 31.6667C7.93398 31.6667 2.73398 19.1 10.084 11.75C17.434 4.4 30.0007 9.61667 30.0007 20H25.0007L31.6673 26.6667H31.834L38.334 20H33.334C33.334 16.0218 31.7536 12.2064 28.9406 9.3934C26.1275 6.58035 22.3122 5 18.334 5C14.3557 5 10.5404 6.58035 7.72738 9.3934C4.91434 12.2064 3.33398 16.0218 3.33398 20Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reload.d79098f9.svg";
export { ForwardRef as ReactComponent };